import { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import SessionExpiredModal from './components/SessionExpiredModal';
import AutoLogoutModal from './components/AutoLogoutModal';
import Footer from './common/Footer/Footer';
import Header from './common/Header/Header';
const Main = lazy(() => import('./components/dashboard/Main'));
const Dashboard = lazy(() => import('./components/dashboard/Dashboard'));
const Welcome = lazy(() => import('./components/auth/Welcome'));
const Profile = lazy(() => import('./components/Profile/Profile'));

// Loading component
const LoadingSpinner = () => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    background: '#F5F7FA'
  }}>
    <div style={{
      border: '4px solid rgba(45, 157, 146, 0.2)',
      borderTop: '4px solid #2D9D92',
      borderRadius: '50%',
      width: '50px',
      height: '50px',
      animation: 'spin 1s linear infinite'
    }}></div>
  </div>
);

// Protected Route Component - Following auth0 reference pattern with dual support
const ProtectedRoute = ({ children }) => {
  const isMsalAuthenticated = useIsAuthenticated();
  const { inProgress } = useMsal();
  const location = useLocation();

  // Show loading while MSAL is processing
  if (inProgress !== InteractionStatus.None) {
    return <LoadingSpinner />;
  }

  // Allow access only if authenticated via MSAL
  if (!isMsalAuthenticated) {
    return <Navigate to="/" state={{ returnTo: location.pathname }} replace />;
  }

  return children;
};

function App() {
  return (
    <Router>
      <SessionExpiredModal />
      <AutoLogoutModal />
      <Header />
      <Suspense fallback={<LoadingSpinner />}>
        <Routes>
          {/* Main/Login Page */}
          <Route path="/" element={<Main />} />

          {/* Dashboard - Protected */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            }
          />
          {/* Welcome/System Pages - Protected */}
          <Route
            path="/dashboard/:system"
            element={
              <ProtectedRoute>
                <Welcome />
              </ProtectedRoute>
            }
          />
          {/* Catch all - redirect to home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
      <Footer />
    </Router>
  );
}

export default App;